export const baseUrl = 'https://qaapi.coffeepass.io';
//'https://qaapi.coffeepass.io'; //'https://prodapi.coffeepass.io';
